export enum MissionObjectiveConditionTypeEnum {
  QUANTITY = 'quantity',
  SUCCESSIVE_QUANTITY = 'successive_quantity',
  TOTAL_BET_AMOUNT = 'total_bet_amount',
  TOTAL_WIN_AMOUNT = 'total_win_amount',
}
